import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../actions';

/**
 * ResumeAuthFlowPage Component
 */
export class ResumeAuthFlowPage extends Component {

  static propTypes = {
    getResumeAuthFlowToken: PropTypes.func.isRequired,
    startResumeAuthFlow: PropTypes.func.isRequired,
    resumeAuthFlowTokenUrl: PropTypes.string,
    resumeAuthFlowToken: PropTypes.string,
    sessionService: PropTypes.string,
    resumeAuthFlowStarted: PropTypes.bool,
  };

  componentDidUpdate() {
    if (this.props.resumeAuthFlowToken && this.props.sessionService && this.props.resumeAuthFlowStarted === false) {
      setTimeout( () => this.props.startResumeAuthFlow(), 100);
    }
  }

  componentDidMount() {
    if (this.props.resumeAuthFlowTokenUrl) {
      this.props.getResumeAuthFlowToken();
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  const {
    resumeAuthFlowToken, sessionService, resumeAuthFlowStarted, resumeAuthFlowTokenUrl,
  } = state.login;
  return {
    resumeAuthFlowToken, sessionService, resumeAuthFlowStarted, resumeAuthFlowTokenUrl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getResumeAuthFlowToken: () => {
      dispatch(actions.getResumeAuthFlowToken() );
    },
    startResumeAuthFlow: () => {
      dispatch(actions.startResumeAuthFlow() );
    },
  };
};

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(ResumeAuthFlowPage);
